import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import SmallTextInputNoBorderLoading from "../components/misc/SmallTextInputNoBorderLoading";
import { LanguageContext } from "../context/LanguageContext";
import { usePremiumStatus } from "../hooks/usePremiumStatus";
import { usePortalUrl } from "../hooks/usePortalUrl";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import SmallTextInputNoBorderMobile from "../components/misc/SmallTextInputNoBorderMobile";

const SettingsContentMobile = () => {
  const { currentUser } = useAuth();
  const [profileUser, setProfileUser] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [, setSelectedLanguage] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const { translate, language } = useContext(LanguageContext);
  const [isPremium, subscriptionDetails, premiumError] = usePremiumStatus();
  const { url: portalUrl, loading, error } = usePortalUrl();
  const navigate = useNavigate();

  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    setSelectedLanguage(newLanguage);
    updateLanguage(newLanguage);
  };

  const handlePricingRedirect = () => {
    navigate("/pricing");
  };

  console.log("isPremium: ", isPremium);

  const handlePortalRedirect = () => {
    if (portalUrl) {
      window.location.href = portalUrl;
    } else {
      alert("Erreur : Impossible de charger l'URL du portail.");
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setIsFetching(true);
      try {
        const userRef = doc(db, "roles", currentUser.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          setProfileUser(userSnap.data());
          setIsFetching(false);
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (currentUser?.uid) {
      fetchUserData();
    }
  }, [currentUser?.uid]);

  const updateLanguage = async (newLanguage) => {
    setIsSaving(true);
    try {
      const userDocRef = doc(db, "roles", currentUser.uid);
      await updateDoc(userDocRef, {
        language: newLanguage,
      });

      setProfileUser((prevProfile) => ({
        ...prevProfile,
        language: newLanguage,
      }));
    } catch (error) {
      console.error("Error updating language:", error);
    } finally {
      setIsSaving(false);
    }
  };

  if (premiumError) {
    return (
      <div className="generate-content">
        <div>Error: {premiumError?.message}</div>;
      </div>
    );
  }

  <div className="generate-content">
    {" "}
    <p>Error: {error?.message}</p>;
  </div>;

  const planContent = isPremium ? "Premium Plan" : profileUser?.role;

  return (
    <div className="pricing-content-mobile">
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          alignContent: "center",
        }}
      >
        <div
          className="main-title-homepage"
          style={{
            fontSize: "24px",
            paddingLeft: "20px",
            paddingTop: "10px",
          }}
        >
          {translate("profile")}
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div style={{ width: "50%" }}>
          <div
            style={{
              paddingLeft: "20px",
              paddingTop: "20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignContent: "start",
              alignItems: "start",
            }}
          >
            <div
              className="label-button-group"
              style={{
                paddingLeft: "0px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ paddingRight: "40px" }}>
                <SmallTextInputNoBorderMobile
                  label={translate("displayedName")}
                  content={currentUser?.displayName}
                  width="250px"
                />
              </div>
              <div style={{ paddingRight: "40px" }}>
                <SmallTextInputNoBorderMobile
                  label={translate("email")}
                  content={currentUser?.email}
                  width="250px"
                />
              </div>
            </div>

            <div
              className="label-button-group"
              style={{
                paddingLeft: "0px",
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            ></div>
            <div
              className="label-button-group-mobile"
              style={{
                paddingLeft: "0px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ paddingBottom: "10px" }}>
                {translate("language")}
              </div>

              <div style={{ width: "200px" }}>
                <select
                  value={language}
                  style={{
                    marginRight: "5px",
                    backgroundColor: "#181b20",
                    color: "white",
                    border: "1px solid #767474",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    outline: "none",
                  }}
                  onChange={handleLanguageChange}
                >
                  <option value="en">English</option>
                  <option value="fr">Français</option>
                  <option value="es">Español</option>
                  <option value="de">Deutsch</option>
                </select>
              </div>

              {isSaving && (
                <div
                  style={{
                    color: "red",
                    width: "100px",
                    textAlign: "center",
                    paddingTop: "3px",
                    fontSize: "14px",
                  }}
                >
                  {translate("saving")}
                </div>
              )}
            </div>

            <div
              className="label-button-group-mobile"
              style={{
                paddingLeft: "0px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <SmallTextInputNoBorderLoading
                  label={translate("plan")}
                  content={planContent}
                  isLoading={isFetching}
                />

                <div>
                  {subscriptionDetails?.currentPeriodStart && (
                    <div className="normalText-mobile">
                      Subscription Start:{" "}
                      <span className="normalTextWhite-mobile">
                        {subscriptionDetails.currentPeriodStart.toLocaleString()}
                      </span>
                    </div>
                  )}

                  {subscriptionDetails?.currentPeriodEnd && (
                    <div className="normalText-mobile">
                      Subscription End:{" "}
                      <span className="normalTextWhite-mobile">
                        {subscriptionDetails.currentPeriodEnd.toLocaleString()}
                      </span>
                    </div>
                  )}

                  {subscriptionDetails?.canceledAt ? (
                    <div className="normalText-mobile">
                      Canceled At:{" "}
                      <span className="normalTextWhite*mobile">
                        {subscriptionDetails.canceledAt.toLocaleString()}
                      </span>
                    </div>
                  ) : (
                    subscriptionDetails && (
                      <div className="normalText-mobile">Canceled At: N/A</div>
                    )
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignContent: "flex-start",
                  alignItems: "flex-start",
                  paddingBottom: "9px",
                  paddingLeft: "5px",
                  marginTop: "10px",
                }}
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <div
                    style={{
                      width: "200px",
                      height: "20px",
                      backgroundColor: "#ab73ee",
                      borderRadius: "5px",
                      color: "white",
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    // onClick={() => {
                    //   if (url) window.location.href = url;
                    // }}
                    onClick={
                      isPremium ? handlePortalRedirect : handlePricingRedirect
                    }
                  >
                    {translate("changePlan")}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsContentMobile;
